/*
 * Latest episode box: auto-fill from the Cozy Storytime app.
 * The server-rendered editor content is the fallback. It is only replaced when
 * the app returns a valid episode that differs from the one in the editor.
 * Text is set with textContent only.
 */
(function () {
  var APP_PREFIX = 'https://app.cozystorytime.com/';
  var PODCAST_PREFIX = 'https://pod.link/';
  var TIMEOUT_MS = 3000;

  function isString(value) {
    return typeof value === 'string' && value.trim() !== '';
  }

  function startsWith(value, prefix) {
    return isString(value) && value.indexOf(prefix) === 0;
  }

  // Episode identity is the app path. Query and hash are not part of it,
  // so campaign UTMs already on the href still match the editor's episode.
  function sameEpisodeUrl(left, right) {
    if (left === right) return true;
    try {
      var a = new URL(left);
      var b = new URL(right);
      return a.protocol === b.protocol && a.host === b.host && a.pathname === b.pathname;
    } catch (e) {
      return false;
    }
  }

  function isHttpsUrl(value) {
    if (!isString(value)) return false;
    try {
      return new URL(value).protocol === 'https:';
    } catch (e) {
      return false;
    }
  }

  // Copy rules: no em dashes in customer copy.
  function cleanText(value) {
    return value
      .replace(/\s*\u2014\s*/g, ', ')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function formatDate(value) {
    if (!isString(value)) return null;
    var date = new Date(value);
    if (isNaN(date.getTime())) return null;
    try {
      return date.toLocaleDateString('en-US', {
        month: 'short',
        day: 'numeric',
        year: 'numeric',
        timeZone: 'America/New_York',
      });
    } catch (e) {
      return null;
    }
  }

  function fill(box, data) {
    var button = box.querySelector('.cozy-ep__button');
    var title = box.querySelector('.cozy-ep__title');
    if (!button || !title) return 'fallback';
    if (!data || !startsWith(data.app_url, APP_PREFIX)) return 'fallback';
    // display_title already includes the episode number and guest author.
    var heading = isString(data.display_title) ? data.display_title : data.title;
    if (!isString(heading)) return 'fallback';

    // Same episode as the editor content: keep the editor's curated copy.
    if (sameEpisodeUrl(button.getAttribute('href'), data.app_url)) return 'editor-current';

    // Work everything out before touching the page.
    var titleText = cleanText(heading);
    var dateText = formatDate(data.published_at);
    // The app trims the description at a full sentence, so use it as-is.
    var blurbText = isString(data.description) ? cleanText(data.description) : null;
    var artUrl = isHttpsUrl(data.artwork_url) ? data.artwork_url : null;
    var podcastUrl = startsWith(data.podcast_url, PODCAST_PREFIX) ? data.podcast_url : null;

    var date = box.querySelector('.cozy-ep__date');
    var blurb = box.querySelector('.cozy-ep__blurb');
    var art = box.querySelector('.cozy-ep__art');
    var podcast = box.querySelector('.cozy-ep__podcast');

    title.textContent = titleText;
    button.setAttribute('href', data.app_url);
    if (date && dateText) date.textContent = dateText;
    if (blurb && blurbText) {
      var p = document.createElement('p');
      p.textContent = blurbText;
      blurb.textContent = '';
      blurb.appendChild(p);
    }
    if (art && artUrl) {
      art.removeAttribute('srcset');
      art.removeAttribute('sizes');
      art.setAttribute('src', artUrl);
      art.setAttribute('alt', 'Cover art for ' + titleText);
    }
    if (podcast && podcastUrl) podcast.setAttribute('href', podcastUrl);

    return 'filled';
  }

  function run(box) {
    var endpoint = box.getAttribute('data-cozy-ep-autofill');
    if (!startsWith(endpoint, APP_PREFIX) || !window.fetch) return;

    var done = false;
    var controller = window.AbortController ? new AbortController() : null;
    function finish(state) {
      if (done) return;
      done = true;
      clearTimeout(timer);
      box.setAttribute('data-cozy-ep-state', state);
    }
    var timer = setTimeout(function () {
      if (controller) controller.abort();
      finish('fallback');
    }, TIMEOUT_MS);

    box.setAttribute('data-cozy-ep-state', 'loading');

    fetch(endpoint, {
      credentials: 'omit',
      headers: { Accept: 'application/json' },
      signal: controller ? controller.signal : undefined,
    })
      .then(function (response) {
        if (!response.ok) throw new Error('HTTP ' + response.status);
        return response.json();
      })
      .then(function (data) {
        if (done) return;
        var state;
        try {
          state = fill(box, data);
        } catch (e) {
          state = 'fallback';
        }
        finish(state);
      })
      .catch(function () {
        finish('fallback');
      });
  }

  if (typeof module !== 'undefined' && module.exports) {
    module.exports = { sameEpisodeUrl: sameEpisodeUrl };
  }

  if (typeof document === 'undefined') return;

  function init() {
    var boxes = document.querySelectorAll('[data-cozy-ep-autofill]');
    for (var i = 0; i < boxes.length; i++) run(boxes[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
